import classNames from "classnames";

type OptionType = { id: string, descrizione?: string }
const options: OptionType[] = [{id: 'DR'}, {id: 'QD'}, {id: 'IM'}, {id: 'IN'}, {id: 'OP'}, {id: 'AP'}, {id: 'altre', descrizione: 'Altre'}];

interface GlossarioProps {
    value: string[];
    setValue: (item: string[]) => void;
}

export const OptionsBar: React.FC<GlossarioProps> = ({value, setValue}) => {
    const className = 'w-2/12 text-center text-blue-800 border border-blue-500 bg-blue-50 rounded-sm hover:font-bold';
    return (
        <div className="flex flex-row text-sm bg-white w-1/2 max-[1170px]:w-full max-[1170px]:text-xs">
            <nav className="select-none w-full inline-flex -space-x-px shadow-md m-3">
                <a className={classNames(className, value.length === 0 ? 'bg-blue-500 text-white font-semibold' : undefined)}
                   onClick={() => {
                       setValue([])
                   }}>*</a>
                {options.map((item) => {
                    return (<a key={item.id}
                               className={classNames(className, value.indexOf(item.id) >= 0 ? 'bg-blue-500 text-white font-semibold' : undefined)}
                               onClick={() => {
                                   let newVal: string[] = []
                                   if (value.indexOf(item.id) >= 0) {
                                       newVal = value.filter((i) => i !== item.id);
                                   } else {
                                       newVal = newVal.concat(value);
                                       newVal.push(item.id)
                                   }
                                   setValue(newVal)
                               }}>
                        {item.descrizione||item.id}
                    </a>)
                })}
            </nav>
        </div>
    )
}
export default OptionsBar;